import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

type OwnProps = {
  fullSize?: {
    fullHeight: boolean;
    fullWidth: boolean;
  };
  className?: string;
  node?: HTMLElement | null;
};

const Modal: React.FC<Partial<React.HTMLAttributes<HTMLElement>> & OwnProps> =
  ({
    children,
    fullSize = { fullHeight: true, fullWidth: true },
    className = "",
    style,
    node,
    ...rest
  }) => {
    const [width, setWidth] = useState<number>(0);
    const [height, setHeight] = useState<number>(0);

    const resizeModalWindow = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };

    useEffect(() => {
      resizeModalWindow();
      window.addEventListener("resize", resizeModalWindow);

      return () => {
        window.removeEventListener("resize", resizeModalWindow);
      };
    }, []);

    const sizeStyle = () => {
      const { fullHeight, fullWidth } = fullSize;
      const res: React.CSSProperties = {};
      if (fullHeight) {
        res["height"] = height;
      }
      if (fullWidth) {
        res["width"] = width;
      }

      return res;
    };

    return ReactDOM.createPortal(
      <div
        id="modal"
        className={className}
        style={{ ...sizeStyle(), ...style }}
        {...rest}
      >
        {children}
      </div>,
      node ? node : document.querySelector("body")!
    );
  };

Modal.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Modal;
